"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../htmlSerializer/PrismicHtmlSerializer"));

var _InfoCardImage = _interopRequireDefault(require("./InfoCardImage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable react/no-array-index-key */
var SectionInfoCard = function InfoCardComponent(_ref) {
  var dataClient = _ref.dataClient,
      sliceData = _ref.sliceData;
  var items = sliceData.items,
      sectionTitle = sliceData.primary.info_title;
  return items.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-tier se-tier--relative content-page__info-card-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-col se-col--12 se-col--6Tablet"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "content-page__info-card-title"
  }, dataClient.textToMarkdown(sectionTitle))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-col se-col--12 se-col--6Tablet"
  }, items.map(function (_ref2, idx) {
    var body = _ref2.info_body,
        image1 = _ref2.info_image_1,
        image1Link = _ref2.info_link_1,
        image1Alt = _ref2.info_alt_1,
        image2 = _ref2.info_image_2,
        image2Link = _ref2.info_link_2,
        image2Alt = _ref2.info_alt_2;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "info-card-".concat(idx)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "content-page__info-card"
    }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
      baseClass: "content-page__info-card-body",
      content: body
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "content-page__info-card-images"
    }, /*#__PURE__*/_react["default"].createElement(_InfoCardImage["default"], {
      alt: image1Alt,
      image: image1,
      link: image1Link
    }), /*#__PURE__*/_react["default"].createElement(_InfoCardImage["default"], {
      alt: image2Alt,
      image: image2,
      link: image2Link
    })));
  })))));
};

SectionInfoCard.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sliceData: _propTypes["default"].shape({}).isRequired
};
var _default = SectionInfoCard;
exports["default"] = _default;